<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div.service-card {
        height: 140px;
        border-radius: 5px;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.16), 0 0 0 1px rgba(0,0,0,0.08);
        padding: 15px 5px 5px 5px;
        margin-top: 20px;
        cursor: pointer;
        -webkit-transform: scaleX(1) scaleY(1);
        transform: scaleX(1) scaleY(1);
        transition: .2s;

        &.in-client-network {
            background-color: rgba(0, 177, 175, 0.6);
        }

        &.maintenance-slot {
            background-color: rgba(0, 154, 23, 0.6);
        }

        span.title {
            display: block;
            text-align: center;
            color: black;
            font-size: 17px;
            font-weight: bold;
            font-family: 'Raleway', sans-serif;
        }

        span.address {
            display: block;
            text-align: center;
            margin-top: 5px;
            color: #272727;
            font-family: 'Raleway', sans-serif;

            span.street {
                font-size: 15px;
                display: block;
            }

            span.city {
                font-size: 15px;
                display: block;
            }

            span.distance {
                font-size: 15px;
            }
        }

        &:hover {
            -webkit-transform: scaleX(1.041) scaleY(1.041);
            transform: scaleX(1.041) scaleY(1.041);
            transition: .2s;
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div.service-card {
            height: 130px;

            span.title {
                font-size: 15px;
            }

            span.address {
                span.street {
                    font-size: 12px;
                }

                span.city {
                    font-size: 12px;
                }

                span.distance {
                    font-size: 12px;
                }
            }
        }
    }
</style>

<template>
    <div class="large-12 medium-12 small-12 cell service-card-container" v-show="show">
        <router-link :to="{ name: 'service', params: { slug: service.slug} }" v-on:click.native="panToLocation(service)">
            <div class="service-card" :class="[service.client_preference == 1 ? 'in-client-network' : '', (service.maintenance_slot == true && !this.makeId) ? 'maintenance-slot': '']">
                <span class="title">{{ service.name }}</span>

                <span class="address">
                    <span class="street">{{ service.street }}</span>
                    <span class="city">{{ service.city }}</span>
                    <span class="distance">{{ service.distance }} km</span>
                </span>
            </div>
        </router-link>
    </div>
</template>

<script>
    import { ServiceTypeFilter } from '../../mixins/filters/ServiceTypeFilter.js';
    import { EventBus } from '../../event-bus.js';

    export default {
        props: [
            'service'
        ],

        data() {
            return {
                show: true
            }
        },

        mixins: [
            ServiceTypeFilter
        ],

        mounted() {
            EventBus.$on('filters-updated', function(filters) {
                this.processFilters(filters);
            }.bind(this));

            this.processFilters();
        },

        computed: {
            distanceFilter() {
                return this.$store.getters.getDistanceFilter;
            },

            activeLocationFilter() {
                return this.$store.getters.getActiveLocationFilter;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },
        },

        watch: {
            distanceFilter() {
                this.processFilters();
            },

            activeLocationFilter() {
                this.processFilters();
            },
        },

        methods: {
            processFilters() {
                if (this.activeLocationFilter == 'all') {
                    this.show = true;
                } else {
                    var typePassed = false;

                    if (this.processServiceTypeFilter(this.service, this.activeLocationFilter)) {
                        typePassed = true;
                    }

                    if (typePassed) {
                        this.show = true;
                    } else {
                        this.show = false;
                    }
                }
            },

            panToLocation(service) {
                EventBus.$emit('location-selected', {
                    lat: parseFloat(service.latitude),
                    lng: parseFloat(service.longitude)
                });
            }
        }
    }
</script>
